import type React from 'react';
import ReactMarkdown, { type NodeType } from 'react-markdown';
import styled from 'styled-components';

const StyledReactMarkdown = styled(ReactMarkdown)`
  position: relative;
  color: ${({ theme }) => theme.palette.text.secondary};
  font0size: 0.7rem;
  line-height: 1.3;
  flex-basis: 100%;

  a {
    color: ${({ theme }) => theme.palette.primary.main};
  }
`;

const allowedTypes: NodeType[] = ['Text', 'Emph', 'Strong', 'Link', 'Code'];

export type InstructionsProps = {
  readonly value: string;
};

const Instructions: React.FC<InstructionsProps> = (props) => {
  const { value } = props;

  return <StyledReactMarkdown allowedTypes={allowedTypes} unwrapDisallowed escapeHtml source={value} />;
};

export default Instructions;
